import axios from 'axios';
import { patchFiles, postFiles } from '../util/axios';
import { isNilOrEmpty } from '../util/redux';

export const apiLogin = ({ email, ...payload }) => axios.post('/login', { email: email.toLowerCase(), ...payload });
export const apiLogout = () => axios.post('/logout');
export const apiRegister = ({ email, ...payload }) =>
  axios.post('/register', { email: email.toLowerCase(), ...payload });
export const apiForgotPassword = ({ email, ...payload }) =>
  axios.post('/password/email', { email: email.toLowerCase(), ...payload });
export const apiResetPassword = ({ email, ...payload }) =>
  axios.post('/password/reset', { email: email.toLowerCase(), ...payload });
export const apiUpdateProfile = (payload) => axios.patch('/api/profile', payload);
export const apiUpdateProfileFiles = (files) => patchFiles('/api/profile', files);
export const apiAddFile = (payload) => postFiles(`/api/profile/file`, payload);
export const apiAddAddress = (payload) => axios.post('/api/profile/address', payload);
export const apiUpdateAddress = ({ id, ...payload }) => axios.patch(`/api/profile/address/${id}`, payload);
export const apiDeleteAddress = (id) => axios.delete(`/api/profile/address/${id}`);

export const apiGetCertifications = (id) => axios.get(`/api/admin/user/${id}/certifications`);
export const apiGetPayments = () => axios.get(`/api/profile/payments`);
export const apiGetPayment = (id) => axios.get(`/api/profile/payments/${id}`);

export const apiSearchData = () => axios.get('/api/users/data');
export const apiSearchUsers = ({ page, filtered, member }) => {
  const filter = filtered
    .filter((column) => !isNilOrEmpty(column[1]) && column[1] !== false)
    .map((column) => `${column[0]},${column[1]}`);
  return axios.get(`/api/users/${member ? 'members' : 'professionals'}`, { params: { limit: 10, page, filter } });
};
export const apiGetUsers = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/admin/users`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiContactProfessional = (id, payload) => axios.post(`/api/users/professionals/${id}`, payload);
export const apiGetUser = (id) => axios.get(`/api/admin/user/${id}`);

export const apiCreateUserNote = (id, payload) => axios.post(`/api/admin/user/${id}/note`, payload);
export const apiUpdateUserNote = (userId, { id, payload }) =>
  axios.patch(`/api/admin/user/${userId}/note/${id}`, payload);
export const apiDeleteUserNote = (id, noteId) => axios.delete(`/api/admin/user/${id}/note/${noteId}`);

export const apiCreateUserFlag = (id, payload) => axios.post(`/api/admin/user/${id}/flag`, payload);
export const apiUpdateUserFlag = (userId, payload) => axios.patch(`/api/admin/user/${userId}/flag/${payload.id}`, payload);

export const apiGetGroups = () => axios.get('/api/admin/groups');
export const apiAddUserGroups = (id, payload) => axios.post(`/api/admin/user/${id}/group`, payload);
export const apiRemoveUserGroup = (id, groupId) => axios.delete(`/api/admin/user/${id}/group/${groupId}`);

export const apiDonate = ({ token, ...payload }) => axios.post('/api/donate', { stripeToken: token, ...payload });
